import Alpine from 'alpinejs'

export const initJSEssentials = () => {
    Alpine.data('jsEssentials', () => ({
        mouse: false,
        init() {
            //Detect touch
            this.initTouchDetect()
            //Detect if JS is present
            this.jsDetect()
            //Prerender fix
            this.prerenderFix()
        },
        initTouchDetect() {
            // Check for touch capabilities
            if ('ontouchstart' in document.documentElement) {
                this.$el.classList.add('touch')
            }
        },
        onPointerMove(e: PointerEvent) {
            //Why is this undefined?
            if (!this.mouse && e.pointerType === 'mouse') {
                // User is using mouse after all
                this.mouse = true
                this.$el.classList.remove('touch')
            } else if (this.mouse && e.pointerType === 'touch') {
                // User is using touch (again)
                this.mouse = false
                this.$el.classList.add('touch')
            }
        },
        destroy() {
            // Clean up event listener when no longer needed
            this.$el.removeEventListener('pointermove', this.onPointerMove)
        },
        jsDetect() {
            this.$el.classList.remove('no-js')
        },
        prerenderFix() {
            const doc = document as Document & { prerendering?: boolean }
            if (doc.prerendering) {
                document.addEventListener('prerenderingchange', () => {
                    // Pagina is nu zichtbaar, transitions zijn safe
                    document.body.classList.remove('no-transition')
                })
                // Disable transitions tijdens prerender
                document.body.classList.add('no-transition')
            }
        },
    }))
}
